import React from 'react';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

import SideBeam from '../components/Contact/SideBeam';
import MainBeam from '../components/Contact/MainBeam/MainBeam';

const ContactPage = ({ location }) => {
  return (
    <>
      <SEO
        title="Contact us | Ulam Labs"
        description="Talk to us about custom software development. We provide full scope support throughout the product lifecycle for web, mobile, and blockchain apps."
      />
      <div className="container-fluid contact-page-wrapper p-0">
        <div className="container">
          <div className="row">
            <div className="col-5 col-md-6 col-lg-3 order-1">
              <SideBeam
                layoutSetup={{
                  withLink: false,
                  mainText: true
                }}
              />
            </div>
            <div className="col-12 col-lg-6 order-3 order-lg-2">
              <MainBeam location={location} />
            </div>
            <div className="col-7 col-md-6 col-lg-3 order-2 order-lg-3">
              <SideBeam
                layoutSetup={{
                  withLink: true,
                  mainText: false
                }}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
